import { ITimeZoneConfig } from '@platform500services/p500-ui-kit';
import { getGMT } from './helpers';
import { ITimeZoneSettings } from './settings.interface';
import moment from 'moment';

const settings: ITimeZoneSettings = {
  name: 'UTC',
  offsetMs: 0,
  offsetMm: 0,
  gmt: '+0000',
};
export class TimeZoneConfig implements ITimeZoneConfig {
  private static self: TimeZoneConfig;
  constructor(tokenKey = '') {
    if (TimeZoneConfig.self) {
      return TimeZoneConfig.self;
    }
    try {
      const token = localStorage.getItem('token') || tokenKey;
      const timeZone = JSON.parse(atob(token.trim().split('.')[1]))?.user?.timezone;
      const date = new Date();
      const utc = date.toLocaleString('en', { timeZone: 'UTC' });
      const locale = date.toLocaleString('en', { timeZone });
      const ms = Date.parse(locale) - Date.parse(utc);
      settings.name = timeZone;
      settings.offsetMs = ms;
      settings.offsetMm = ms / 1000 / 60;
      settings.gmt = getGMT(settings.offsetMm);
      TimeZoneConfig.self = this;
    } catch {}
  }

  public get name(): string {
    return settings.name;
  }

  public get offsetMs(): number {
    return settings.offsetMs;
  }

  public get offsetMm(): number {
    return settings.offsetMm;
  }

  public get gmt(): string {
    return settings.gmt;
  }

  public getDate(date: Date | string | number, params?: { pretty?: boolean }): string {
    let resultDate: Date | string = new Date(date);
    const time = resultDate.getTime();
    if (!isNaN(time) && time > 0) {
      resultDate = new Date(time + this.offsetMs);
    }
    resultDate = resultDate.toISOString();
    if (params?.pretty) {
      resultDate = moment(resultDate).utc().format('YYYY-MM-DD HH:mm');
    }
    return resultDate;
  }
}
